import axios from "axios";
import {
  API_SERVICE_BACKEND,
  API_SERVICE_BACKEND_ANALYTICS_DATA,
} from "src/config";

export const getAnalyticsData = async (userId, dateRange = null) => {
  try {
    const response = await axios.get(
      `${API_SERVICE_BACKEND_ANALYTICS_DATA}/api/track/user/${userId}`,
      {
        params: {
          dateRange,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching analytics data:", error);
    throw error;
  }
};

export const getVisitorsByCountry = async (userId) => {
  try {
    const response = await axios.get(
      `${API_SERVICE_BACKEND_ANALYTICS_DATA}/api/track/map/${userId}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching visitors by country data:", error);
    throw error;
  }
};

export const addDomain = async (userId, domain) => {
  try {
    const response = await axios.post(
      `${API_SERVICE_BACKEND_ANALYTICS_DATA}/api/domain/add-domain`,
      {
        userId,
        domain,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding domain:", error);
    throw error;
  }
};

export const verifyDomain = async (userId, domain) => {
  try {
    const response = await axios.post(
      `${API_SERVICE_BACKEND_ANALYTICS_DATA}/api/domain/verify-domain`,
      {
        userId,
        domain,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying domain:", error);
    throw error;
  }
};

export const getDomains = async (userId) => {
  try {
    const response = await axios.get(
      `${API_SERVICE_BACKEND_ANALYTICS_DATA}/api/domain/get-domains/${userId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching domains:", error);
    throw error;
  }
};
export const getVisitorsByDays = async (userId, days) => {
  try {
    const response = await axios.get(
      `${API_SERVICE_BACKEND_ANALYTICS_DATA}/api/track/visitors/${userId}/${days}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching visitors by days:", error);
    throw error;
  }
};

// analytics : global analytics chart and stats
export const getGlobalAnalyticsInfo = async ({
  email,
  campaignIds,
  params,
}) => {
  // //console.log(campaignId)
  const res = await axios.post(
    `${API_SERVICE_BACKEND}/analytics/global-analytics/`,
    {
      clientEmail: email,
      campaignIds,
      ...(params ? params : {}),
    }
  );
  if (res.status === 200) {
    return res.data.data;
  } else {
    throw new Error(res.data);
  }
};

export const getGlobalAnalyticsCount = async ({
  email,
  campaignIds,
  params,
}) => {
  const res = await axios.post(
    `${API_SERVICE_BACKEND}/analytics/global-analytics/v2`,
    {
      clientEmail: email,
      campaignIds,
      ...(params ? params : {}),
    }
  );
  if (res.status === 200) {
    return res.data.data;
  } else {
    throw new Error(res.data);
  }
};

export const getGlobalAnalyticsV3 = async ({ email, campaignIds, params }) => {
  const res = await axios.post(
    `${API_SERVICE_BACKEND}/analytics/global-analytics/v3`,
    {
      clientEmail: email,
      campaignIds,
      ...(params ? params : {}),
    }
  );
  if (res.status === 200) {
    return res?.data?.data?.[0] ?? null;
  } else {
    throw new Error(res.data);
  }
};
// analytics : global analytics chart and stats : Inbound

export const getInboundGlobalAnalyticsInfo = async ({
  clientEmail,
  aiAgentIds,
  params,
}) => {
  //as aiAgentIds is array of objects with inboundAgentId field only extract that field and sense array of ids
  const res = await axios.post(
    `${API_SERVICE_BACKEND}/inbound-analytics`,
    {
      clientEmail,
      aiAgentIds,
      from: params?.from || null,
      to: params?.to || null,
    }
  );
  if (res.status === 200) {
    return res.data.data;
  } else {
    throw new Error(res.data);
  }
}
